module.exports = __webpack_public_path__ + "img/04.4d50fb69.jpg";